import { getCurrencyText } from '@/model/Helpers'

export interface TierInfo {
    upTo: number|null
    price: number
}

export default new class SubscriptionValues {
    monthlyPriceId = process.env.VUE_APP_PRICE_ID_MONTHLY
    yearlyPriceId = process.env.VUE_APP_PRICE_ID_YEARLY
    monthlyTiers: TierInfo[] = [
        {upTo: null, price: 1200},
    ]
    yearlyTiers: TierInfo[] = [
        {upTo: null, price: 12000},
    ]

    getSubtotalPriceYearly(quantity: number): number {
        return this.getSubtotalPrice(this.yearlyTiers, quantity)
    }

    getSubtotalPrice(tiers: TierInfo[], quantity: number): number {
        let total = 0;
        let quantityRemaining = quantity
        for (let i = 0; i < tiers.length && quantityRemaining > 0; i++) {
            const prevUpTo = (i === 0) ? 0 : (tiers[i-1].upTo || Number.MAX_SAFE_INTEGER)
            const upTo = tiers[i].upTo || Number.MAX_SAFE_INTEGER
            const tierQuantity = Math.min(quantityRemaining, upTo - prevUpTo)
            const tierPrice = tiers[i].price * tierQuantity
            total += tierPrice
            quantityRemaining -= tierQuantity
        }
        return total
    }

    getPriceText(price: number): string {
        if (price < 0)
            return '---'

        // convert price from cents to dollars
        return getCurrencyText(price)
    }
}